import apollo from '@/graphql'

import BrandDetailsQuery from '@/graphql/brand/BrandDetailsQuery.gql'
import SaveBrandDetails from '@/graphql/brand/SaveBrandDetails.gql'

// initial state
const state = {
  brandDetails: {},
  editableBrandFields: {},
}

// getters
const getters = {
  brandDetails: st => st.brandDetails,
  editableBrandFields: st => st.editableBrandFields,
}

// mutations
const mutations = {
  createBrandDetails() {
    state.brandDetails = { name: 'Create New Brand' }

    state.editableBrandFields = {
      categoriesId: null,
      vendorsId: null,
    }
  },

  setBrandDetails(st, brandDetails) {
    state.brandDetails = brandDetails
  },

  setEditableBrandFields(st, brandDetails) {
    state.editableBrandFields = {
      categoriesId: brandDetails.category.id,
      id: brandDetails.id,
      name: brandDetails.name,
      vendorsId: brandDetails.vendor.id,
    }
  },
}

// actions
const actions = {
  loadBrandDetails({ commit }, { id }) {
    apollo.defaultClient.watchQuery({
      fetchPolicy: 'network-only',
      query: BrandDetailsQuery,
      variables: { id: +id },
    }).subscribe(({ data: { brandDetails } }) => {
      commit('setBrandDetails', brandDetails)
      commit('setEditableBrandFields', brandDetails)
    })
  },

  saveBrandDetails(context, { $message, $router }) {
    apollo.defaultClient.mutate({
      mutation: SaveBrandDetails,
      variables: { fields: state.editableBrandFields },
      refetchQueries: [state.brandDetails.id].filter(id => id).map(id => ({
        query: BrandDetailsQuery,
        variables: { id: +id },
      })),
    }).then(({ data: { saveBrandDetails: { id } } }) => {
      $message({ message: 'Changes saved' })
      $router.push(`/brand/${id}`)
    }).catch((err) => {
      $message.error(err.message)
    })
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
}



// WEBPACK FOOTER //
// ./src/store/modules/brand/BrandDetails.js